'use es6';

import { Popover } from 'foundations-components/transitional/components/Popover';
import PropTypes from 'prop-types';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakeFilterEditPopover = ({
  onClose,
  open,
  editPanel,
  disabled,
  children
}) => {
  if (disabled) {
    return children;
  }
  return /*#__PURE__*/_jsx(Popover, {
    open: open,
    closeOnOutsideClick: false,
    onOpenChange: ({
      target: {
        value: nextOpen
      }
    }) => {
      if (!nextOpen) {
        onClose();
      }
    },
    arrowSize: "medium",
    placement: "right",
    content: /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: '100vh',
      children: /*#__PURE__*/_jsx(TFlex, {
        padding: "500",
        minInlineSize: "250px",
        maxInlineSize: "400px",
        flexGrow: 1,
        children: editPanel
      })
    }),
    children: children
  });
};
SnowflakeFilterEditPopover.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  editPanel: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.any.isRequired
};
export default SnowflakeFilterEditPopover;